var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCsvCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15996_198972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9663 5.46975C8.93659 5.40417 8.8886 5.34855 8.82807 5.30957C8.76754 5.27059 8.69704 5.2499 8.62505 5.25H7.12505V0.375C7.12505 0.168 6.95705 0 6.75005 0H5.25005C5.04305 0 4.87505 0.168 4.87505 0.375V5.25H3.37505C3.30308 5.25006 3.23265 5.2708 3.17215 5.30976C3.11165 5.34873 3.06362 5.40426 3.0338 5.46975C2.9723 5.604 2.9963 5.76075 3.09305 5.87175L5.71805 8.87175C5.75315 8.91205 5.79648 8.94435 5.84513 8.96647C5.89378 8.98859 5.9466 9.00003 6.00005 9C6.10805 9 6.2108 8.95275 6.28205 8.87175L8.90705 5.87175C9.00455 5.7615 9.02705 5.604 8.9663 5.46975Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 8.25V10.5H1.875V8.25H0.375V11.25C0.375 11.6648 0.711 12 1.125 12H10.875C11.2898 12 11.625 11.6648 11.625 11.25V8.25H10.125Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15996_198972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCsvCollection);
export default __webpack_public_path__ + "static/media/DownloadCSVCollection.1f9c9da69637b27a18bdf367a1bb9056.svg";
export { ForwardRef as ReactComponent };